import React from "react";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Tooltip,
  Typography,
  alpha,
} from "@mui/material";
import {
  Close as CloseIcon,
  Layers as LayersIcon,
  Visibility as VisibilityIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
} from "@mui/icons-material";

export default function AccionesBar({
  state,
  handlePreview,
  totalesCoinciden,
  totalCobrado,
  isSubmitting,
  recObligatorio,
  setImputacionModalOpen,
  aplicable = false,
  onClose,
}) {
  const canProceed = totalesCoinciden && totalCobrado > 0 && !isSubmitting;
  const ret = state.retenciones;
  const retenciones =
    (Number(ret?.retDrei) || 0) +
    (Number(ret?.retIva) || 0) +
    (Number(ret?.retGanancias) || 0) +
    (Number(ret?.retSuss) || 0);

  const totalIibb = ret?.retencionesIIBB.reduce(
    (acc, i) => acc + (Number(i.importe) || 0),
    0,
  );

  const totalRetenciones =
    (Number(retenciones) || 0) + (Number(totalIibb) || 0);

  console.log("Total de las retenciones: ", totalRetenciones);
  const totalEfectivo = Number(state.recibo?.efectivo) || 0;
  const totalTarjeta = state.tarjetas.reduce(
    (acc, t) => (acc || 0) + Number(t.importe),
    0,
  );
  const totalInstrumento = state.instrumentos.reduce(
    (acc, i) => (acc || 0) + Number(i.importe),
    0,
  );
  const totalTotal =
    totalEfectivo + totalTarjeta + totalInstrumento + totalRetenciones;
  const saldoRecibo = state.recibo.totalEsperado;
  const diferencia = totalTotal - Number(saldoRecibo);
  const mensajeTotales = totalesCoinciden
    ? "Los totales coinciden correctamente"
    : diferencia < 0
      ? `Falta cobrar $${Math.abs(diferencia).toLocaleString("es-AR")}`
      : `Hay un excedente de $${diferencia.toLocaleString("es-AR")}`;

  return (
    <div>
      <Box
        sx={{
          position: "sticky",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 10,
        }}
      >
        <Box
          sx={{
            height: 12,
            my: "auto",
            background: (theme) =>
              `linear-gradient(to top, ${theme.palette.background.paper}, transparent)`,
          }}
        />

        <Box
          sx={{
            borderTop: 1,
            borderColor: "divider",
            bgcolor: (theme) => alpha(theme.palette.background.paper, 0.95),
            backdropFilter: "blur(8px)",
            boxShadow: "0 -4px 20px -4px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              px: 3,
              py: 1.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  bgcolor: (theme) =>
                    canProceed
                      ? alpha(theme.palette.success.main, 0.1)
                      : alpha(theme.palette.warning.main, 0.1),
                  transition: "all 0.2s ease",
                }}
              >
                {canProceed ? (
                  <CheckCircleIcon
                    sx={{
                      fontSize: 18,
                      color: "success.main",
                    }}
                  />
                ) : (
                  <WarningIcon
                    sx={{
                      fontSize: 18,
                      color: "warning.main",
                    }}
                  />
                )}
              </Box>
              <Tooltip
                title={
                  <Box sx={{ p: 0.5 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      Resumen del recibo
                    </Typography>

                    <Typography variant="body2">
                      Importe a cobrar:{" "}
                      <strong>
                        ${Number(saldoRecibo).toLocaleString("es-AR")}
                      </strong>
                    </Typography>

                    <Typography variant="body2">
                      Efectivo:{" "}
                      <strong>${totalEfectivo.toLocaleString("es-AR")}</strong>
                    </Typography>

                    <Typography variant="body2">
                      Tarjetas:{" "}
                      <strong>${totalTarjeta.toLocaleString("es-AR")}</strong>
                    </Typography>

                    <Typography variant="body2">
                      Instrumentos:{" "}
                      <strong>
                        ${totalInstrumento.toLocaleString("es-AR")}
                      </strong>
                    </Typography>

                    <Typography variant="body2">
                      Retenciones:{" "}
                      <strong>
                        ${totalRetenciones.toLocaleString("es-AR")}
                      </strong>
                    </Typography>

                    <Typography variant="body2" sx={{ mt: 1 }}>
                      Total ingresado:{" "}
                      <strong>${totalTotal.toLocaleString("es-AR")}</strong>
                    </Typography>

                    {!totalesCoinciden && (
                      <Typography
                        variant="body2"
                        sx={{ mt: 1, fontWeight: 700 }}
                      >
                        {totalTotal < totalCobrado
                          ? `Falta cobrar $${Math.abs(diferencia).toLocaleString("es-AR")}`
                          : `Hay un excedente de $${diferencia.toLocaleString("es-AR")}`}
                      </Typography>
                    )}
                  </Box>
                }
                arrow
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: canProceed ? "success.main" : "warning.main",
                    fontWeight: 500,
                    cursor: "help",
                  }}
                >
                  {canProceed
                    ? "Listo para enviar"
                    : !totalesCoinciden
                      ? mensajeTotales
                      : "Complete los datos requeridos"}
                </Typography>
              </Tooltip>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Button
                onClick={onClose}
                variant="text"
                size="large"
                disabled={isSubmitting || recObligatorio}
                startIcon={<CloseIcon />}
                sx={{
                  color: "text.secondary",
                  "&:hover": {
                    bgcolor: (theme) => alpha(theme.palette.action.hover, 0.08),
                    color: "text.primary",
                  },
                }}
              >
                Cancelar
              </Button>
              {aplicable && (
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => setImputacionModalOpen(true)}
                  disabled={!canProceed}
                  startIcon={<LayersIcon />}
                  sx={{
                    borderColor: "divider",
                    "&:hover": {
                      borderColor: "primary.main",
                      bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, 0.04),
                    },
                    "&:disabled": {
                      borderColor: "divider",
                    },
                  }}
                >
                  Aplicaciones
                  <Chip
                    label={state.imputaciones.length}
                    size="small"
                    sx={{
                      ml: 1,
                      height: 22,
                      minWidth: 22,
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, 0.1),
                      color: "primary.main",
                      "& .MuiChip-label": {
                        px: 1,
                      },
                    }}
                  />
                </Button>
              )}

              <Button
                onClick={handlePreview}
                variant="contained"
                size="large"
                disabled={!canProceed}
                disableElevation
                startIcon={
                  isSubmitting ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : (
                    <VisibilityIcon />
                  )
                }
                sx={{
                  px: 3,
                  boxShadow: (theme) =>
                    `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
                  "&:hover": {
                    boxShadow: (theme) =>
                      `0 6px 20px ${alpha(theme.palette.primary.main, 0.4)}`,
                  },
                  transition: "all 0.2s ease",
                }}
              >
                {isSubmitting ? "Espere un momento..." : "Previsualizar recibo"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
